/******/ (() => { // webpackBootstrap
/* eslint-disable */
class ProductSwatch extends HTMLElement {
  constructor() {
    super();

    /* ===== Bind the event handlers in order to maintain the correct context of 'this' ===== */
    this.onSwatchChangeBound = this.onSwatchChange.bind(this);
    this.onColorSwatchMouseEnterBound = this.onColorSwatchMouseEnter.bind(this);
    this.onSwatchMouseLeaveBound = this.onSwatchMouseLeave.bind(this);
  }

  connectedCallback() {
    this.colorLabelContainer = this.querySelector('[data-color-swatch-name-container]');
    this.colorLabel = this.querySelector('[data-color-swatch-name]');
    this.colorLabelState = this.querySelector('[data-color-swatch-state]');
    this.soldOutString = this.getAttribute('data-swatch-sold-out-string');
    this.colorSwatches = this.querySelectorAll('.swatch-element.color');
    this.sectionId = this.getAttribute('data-section-id');
    this.setEventListeners();
    this.setColorLabelState();

    // === Show correct media on first load ===
        if (window.innerWidth > 768) {
      const defaultActiveSwatch = this.querySelector('.swatch-element.color.active');
      this.updateProductMediaBySwatch(defaultActiveSwatch);
    }
    
  }

  setEventListeners() {
    /* ===== Attach the event listeners to the DOM elements ===== */
    // commeneted to prevent the variant text change on hover on pdp
    // this.colorSwatches.forEach(swatch => {
    //   swatch.addEventListener('mouseenter', this.onColorSwatchMouseEnterBound);
    //   swatch.addEventListener('mouseleave', this.onSwatchMouseLeaveBound);
    // });

    this.addEventListener('change', this.onSwatchChangeBound);
  }

  setColorLabelState() {
    /* ===== Set the color label state based on the active swatch ===== */
    const activeSwatch = this.querySelector('.swatch-element.color.active');
    if (!activeSwatch) return;

    const activeSwatchAvailable = activeSwatch.getAttribute('data-swatch-option-available');
    if (!this.soldOutString || !this.colorLabelState) return;

    // Set color label state (sold out or not)
    this.updateColorLabelState(activeSwatchAvailable);

    /* ===== Keep track of the current label ===== */
    this.currentLabel = '';
    if (this.colorLabel) this.currentLabel = this.colorLabel.textContent;
  }

  updateColorLabelState(available) {
    /* ===== Set the color label state (sold out or not) ===== */
    if (this.colorLabelState) {
      this.colorLabelState.innerText = available === 'false' ? `(${this.soldOutString})` : '';
    }
  }

  onSwatchChange(event) {
    const input = event.target;
    const currentVariant = this.getVariantData(input.id);
    const productUrl = input.getAttribute('data-product-url');
    const productFetchUrl = input.getAttribute('data-product-fetch-url');
    const isCombinedListing = input.getAttribute('data-is-combined-listing') === 'true';

    this.emitVariantChangeEvent(currentVariant, productFetchUrl, productUrl, isCombinedListing);

    // === Update media display based on selected swatch ===
       if (window.innerWidth > 768) {
        const swatchWrapper = input.closest('.swatch-element');
        this.updateProductMediaBySwatch(swatchWrapper);
       }


//     const swatchWrapper = input.closest('.swatch-element');
// if (swatchWrapper) {
//   // Scroll to or activate associated media
//   const label = swatchWrapper.querySelector('label[id]');
//   if (label && label.id) {
//     const mediaLink = document.querySelector(`[data-main-media-link][id="${label.id}"]`);
//     if (mediaLink) {
//       // Scroll into view and highlight
//       mediaLink.scrollIntoView({ behavior: 'smooth' });
//       document.querySelectorAll('[data-main-media-link]').forEach(el => {
//         el.classList.remove('active-media');
//       });
//       mediaLink.classList.add('active-media');
//     }
//   }
// }

  }

updateProductMediaBySwatch(swatchElement) {
  if (!swatchElement) return;

  const label = swatchElement.querySelector('label[id]');
  if (!label || !label.id) return;

  const baseId = label.id.replace(/-\d+$/, '');
  const allMediaLinks = document.querySelectorAll('[data-main-media-link]');

  allMediaLinks.forEach(link => {
    link.style.display = 'none';
    link.classList.remove('active-media');
  });

  const matchingLinks = Array.from(allMediaLinks).filter(link =>
    link.id.startsWith(baseId)
  );

  matchingLinks.forEach((link, index) => {
    link.style.display = '';
    if (index === 0) {
      link.scrollIntoView({ behavior: 'smooth' });
    }
    link.classList.add('active-media');
  });
}
  
  emitVariantChangeEvent(variant, productFetchUrl, productUrl, isCombinedListing = false) {
    /* ===== Emit the variant:change event ===== */
    eventBus.emit('variant:change', {
      sectionId: this.sectionId,
      variant: variant,
      fetchURL: productFetchUrl,
      productURL: productUrl,
      isCombinedListing: isCombinedListing
    });
  }

  onColorSwatchMouseEnter(event) {
    /* ===== Update the color label on mouse enter ===== */
    this.updateColorLabel(event.currentTarget);
    
    // Add sibling hover active class
    const activeSwatch = this.querySelector('.swatch-element.color.active');
    if (activeSwatch && !event.currentTarget.classList.contains('active')) activeSwatch.classList.add('sibling-hover-active');
  }

  onSwatchMouseLeave() {
    /* ===== Reset the color label on mouse leave ===== */
    // Remove sibling hover active class
    const siblingHoverActiveSwatch = this.querySelector('.swatch-element.sibling-hover-active');
    if (siblingHoverActiveSwatch) siblingHoverActiveSwatch.classList.remove('sibling-hover-active');

    // Reset color label
    this.resetColorLabel();
  }

  updateColorLabel = (swatch) => {
    /* ===== Update the color label based on the swatch value ===== */
    if (!swatch) return;
    const label = swatch.getAttribute('data-value');
    const swatchAvailable = swatch.getAttribute('data-swatch-option-available');

    if (!label || !this.colorLabel) return;
    // Set color label text
    this.colorLabel.textContent = label;
    this.animateColorLabel(label);
    // Set color label state (sold out or not)
    this.updateColorLabelState(swatchAvailable);
  }

  resetColorLabel = () => {
    /* ===== Reset the color label to the active swatch value ===== */
    const activeSwatch = this.querySelector('.swatch-element.color.active');
    if (!activeSwatch || !this.colorLabel) return;

    const activeSwatchValue = activeSwatch.getAttribute('data-value');
    const swatchAvailable = activeSwatch.getAttribute('data-swatch-option-available');
    if (!activeSwatchValue) return;

    // Reset color label text
    this.colorLabel.textContent = activeSwatchValue;
    this.animateColorLabel(activeSwatchValue);
    // Reset color label state (sold out or not)
    this.updateColorLabelState(swatchAvailable);
  }

  animateColorLabel(label) {
    if (label === this.currentLabel) return;

    /* ===== Animate the color label if label has changed ===== */
    this.colorLabelContainer.classList.remove('fade-in-label');
    void this.colorLabelContainer.offsetWidth; // Force reflow to reset the animation
    this.colorLabelContainer.classList.add('fade-in-label');

    /* ===== Keep track of the current label ===== */
    this.currentLabel = label;
  }

  removeEventListeners() {
    /* ===== Remove the event listeners from the DOM elements ===== */
    // commeneted to prevent the variant text change on hover on pdp
    // this.colorSwatches.forEach(swatch => {
    //   swatch.removeEventListener('mouseenter', this.onColorSwatchMouseEnterBound);
    //   swatch.removeEventListener('mouseleave', this.onSwatchMouseLeaveBound);
    // });

    this.removeEventListener('change', this.onSwatchChangeBound);
  }

  /* FOR  THIS SCRIPT ATC TO SELECT SIZE START */

// onSwatchChange(event) {
//   const input = event.target;
//   const currentVariant = this.getVariantData(input.id);
//   const productUrl = input.getAttribute('data-product-url');
//   const productFetchUrl = input.getAttribute('data-product-fetch-url');
//   const isCombinedListing = input.getAttribute('data-is-combined-listing') === 'true';

//   this.emitVariantChangeEvent(currentVariant, productFetchUrl, productUrl, isCombinedListing);

//   // ==== Add your custom logic here ====
//   const atcButton = document.querySelector('.size_atc_button');
//   if (atcButton) {
//     // atcButton.classList.add('test_button');
//     atcButton.removeAttribute('disabled');
//     atcButton.classList.remove('size_atc_btn_dasable');
//   }
// }




// onSwatchChange(event) {
//   const input = event.target;

//   // Remove the 'active-size' class from all size swatches
//   document.querySelectorAll('[data-option="Size"]').forEach(swatch => {
//     swatch.classList.remove('active-size');
//   });

//   // Add the 'active-size' class to the clicked swatch
//   input.classList.add('active-size');
// }

// // Event listener for size swatches
// document.querySelectorAll('[data-option="Size"]').forEach(swatch => {
//   swatch.addEventListener('click', onSwatchChange.bind(this)); // Bind to ensure 'this' refers to the current context
// });

  // Delegated click handler (more efficient for dynamic swatches)


    /* FOR  THIS SCRIPT ATC TO SELECT SIZE END */
  
  getVariantData(inputId) {
    return JSON.parse(this.getVariantDataElement(inputId).textContent);
  }

  getVariantDataElement(inputId) {
    return this.querySelector(`script[type="application/json"][data-resource="${inputId}"]`);
  }

  disconnectedCallback() {
    /* ===== Remove the event listeners when the element is removed from the DOM ===== */
    this.removeEventListeners();
  }
}

if (!window.customElements.get('product-swatch')) {
  window.customElements.define('product-swatch', ProductSwatch);
}

/******/ })()
;

/*size varaint underline script start */
// window.addEventListener('load', function() {
//   // Remove the 'size_active' class on initial page load
//   document.querySelectorAll('.swatch-element.size_active').forEach(function(el) {
//     el.classList.remove('size_active');
//   });
// });

document.addEventListener('click', function(event) {
  const clickedSwatch = event.target.closest('.swatch-element[data-option="Size"]');
  
  if (clickedSwatch) {
    // Delay to let the "active" class update first
    setTimeout(function() {
      // Remove 'size_active' from all
      document.querySelectorAll('.swatch-element[data-option="Size"]').forEach(function(el) {
        el.classList.remove('size_active');
      });

      // Add 'size_active' to the one that now has the 'active' class
      const activeSwatch = document.querySelector('.swatch-element.active[data-option="Size"]');
      if (activeSwatch) {
        activeSwatch.classList.add('size_active');
      }
    }, 50); // 50ms delay usually works well
  }
});

document.addEventListener('click', function(event) {
  const clickedSwatch = event.target.closest('.swatch-element[data-option="Size"]');

  if (clickedSwatch) {
    // Delay to wait for variant refresh (common in Shopify themes)
    setTimeout(() => {
      const atcButton = document.querySelector('.size_atc_button');
      if (atcButton) {
        atcButton.removeAttribute('disabled');
        atcButton.classList.remove('size_atc_btn_dasable');
      }
      const preorderNote = document.querySelector('[data-preorder-note]');
      if (preorderNote) {
        preorderNote.classList.remove('preorder-ship-note--requires-size');
      }
    }, 4); // 300ms delay – adjust if needed
  }
});

/*size varaint underline script end */













/* Varaint and lan change issue start */


(function () {
  console.log('variant-preserve: script loaded');

  function findInputByVariantId(variantId) {
    if (!variantId) return null;
    // ප්‍රાથમિક: script[type="application/json"][data-resource]
    const scripts = document.querySelectorAll('script[type="application/json"][data-resource]');
    for (const s of scripts) {
      try {
        const parsed = JSON.parse(s.textContent);
        if (String(parsed.id) === String(variantId)) {
          const inputId = s.getAttribute('data-resource');
          const input = document.getElementById(inputId);
          if (input) return input;
        }
      } catch (e) {/* ignore */}
    }
    //Fallback: swatch element attribute
    const swatch = document.querySelector(`.swatch-element[data-swatch-variant-id="${variantId}"]`);
    if (swatch) return swatch.querySelector('input[type="radio"], input[type="checkbox"]') || null;
    return null;
  }

  function findVariantIdFromInput(input) {
    if (!input) return null;
    // try script[data-resource="{input.id}"]
    const s = document.querySelector(`script[type="application/json"][data-resource="${input.id}"]`);
    if (s) {
      try {
        const parsed = JSON.parse(s.textContent);
        if (parsed && parsed.id) return String(parsed.id);
      } catch (e) {/* ignore */}
    }
    const p = input.closest('.swatch-element');
    if (p && p.dataset.swatchVariantId) return String(p.dataset.swatchVariantId);
    return null;
  }

  function activateInput(input) {
    if (!input) return false;
    const name = input.name;
    if (name) {
      document.querySelectorAll(`input[name="${name}"]`).forEach(i => {
        i.checked = false;
        i.removeAttribute('checked');
        const pr = i.closest('.swatch-element');
        if (pr) pr.classList.remove('active');
      });
    }
    input.checked = true;
    input.setAttribute('checked', '');
    const parent = input.closest('.swatch-element');
    if (parent) parent.classList.add('active');

    // dispatch change so theme handlers react
    input.dispatchEvent(new Event('change', { bubbles: true }));
    console.log('variant-preserve: activated input', input.id, 'parent', parent && parent.className);

    // update URL (so refreshing/return_to use it)
    const vid = findVariantIdFromInput(input);
    if (vid) {
      try {
        const u = new URL(window.location.href);
        u.searchParams.set('variant', vid);
        history.replaceState(null, '', u.toString());
        console.log('variant-preserve: URL updated to', u.toString());
      } catch (e) {/* ignore */}
    }
    return true;
  }

  function applyVariantFromUrl() {
    const variantId = new URL(window.location.href).searchParams.get('variant');
    if (!variantId) return false;
    const input = findInputByVariantId(variantId);
    if (input) return activateInput(input);
    return false;
  }

  function waitForSwatchesAndApply(timeout = 4000) {
    return new Promise(resolve => {
      if (applyVariantFromUrl()) { resolve(true); return; }
      const observer = new MutationObserver(() => {
        if (document.querySelector('script[type="application/json"][data-resource]') || document.querySelector('.swatch-items-wrapper')) {
          if (applyVariantFromUrl()) { observer.disconnect(); resolve(true); return; }
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
      setTimeout(() => { observer.disconnect(); resolve(false); }, timeout);
    });
  }

  function hookLocalizationForms() {
    const forms = document.querySelectorAll('localization-form form, form.localization-form, form#MobileCountryForm, form[action="/localization"]');
    if (!forms || forms.length === 0) {
      console.log('variant-preserve: no localization forms found at hook time');
      return;
    }

    forms.forEach(form => {
      form.addEventListener('submit', function (evt) {
        try {
          // prefer currently selected swatch input
          const checked = document.querySelector('.swatch-element input[type="radio"]:checked, input[type="radio"]:checked');
          let variantId = findVariantIdFromInput(checked);
          if (!variantId) {
            variantId = new URL(window.location.href).searchParams.get('variant');
          }
          if (!variantId) { return; }

          const returnInput = form.querySelector('input[name="return_to"]');
          const currentReturn = returnInput && returnInput.value ? returnInput.value : window.location.href;
          const newReturn = new URL(currentReturn, window.location.origin);
          newReturn.searchParams.set('variant', variantId);

          if (returnInput) {
            returnInput.value = newReturn.toString();
          } else {
            const hidden = document.createElement('input');
            hidden.type = 'hidden';
            hidden.name = 'return_to';
            hidden.value = newReturn.toString();
            form.appendChild(hidden);
          }
          console.log('variant-preserve: localization form submit updated return_to ->', newReturn.toString());
        } catch (err) {
          console.error('variant-preserve: error in localization form submit handler', err);
        }
      }, { passive: false });
    });
  }

  // keep return_to in sync whenever a swatch/input changes (so if user selects variant then taps country, it's preserved)
  document.addEventListener('change', function (e) {
    try {
      const t = e.target;
      if (!t) return;
      if (t.matches && (t.matches('input[type="radio"]') || t.matches('input[type="checkbox"]'))) {
        const vid = findVariantIdFromInput(t);
        if (!vid) return;
        document.querySelectorAll('localization-form form, form.localization-form, form#MobileCountryForm, form[action="/localization"]').forEach(form => {
          try {
            let returnInput = form.querySelector('input[name="return_to"]');
            const currentReturn = returnInput && returnInput.value ? returnInput.value : window.location.href;
            const newReturn = new URL(currentReturn, window.location.origin);
            newReturn.searchParams.set('variant', vid);
            if (returnInput) returnInput.value = newReturn.toString();
            else {
              const i = document.createElement('input'); i.type = 'hidden'; i.name = 'return_to'; i.value = newReturn.toString(); form.appendChild(i);
            }
            console.log('variant-preserve: synched return_to on change ->', newReturn.toString());
          } catch (err) { /* ignore */ }
        });
        // update URL
        try { const u = new URL(window.location.href); u.searchParams.set('variant', vid); history.replaceState(null, '', u.toString()); } catch (e) { /* ignore */ }
      }
    } catch (err) { /* ignore */ }
  });

  // Run after DOM ready, wait for swatches to be available
  document.addEventListener('DOMContentLoaded', function () {
    const urlHasVariant = new URL(window.location.href).searchParams.get('variant');
    if (urlHasVariant) {
      waitForSwatchesAndApply().then(() => {
        hookLocalizationForms();
      });
    } else {
      // Still hook forms so if user selects a variant then submits form it's preserved
      hookLocalizationForms();
    }
  });

  // If sections reload via shopify events, re-run activation
  document.addEventListener('shopify:section:load', function () {
    applyVariantFromUrl();
    hookLocalizationForms();
  });

  // Small safety: try again a little later in case module loading order differs
  setTimeout(function () { applyVariantFromUrl(); hookLocalizationForms(); }, 1200);

})();


/* Varaint and lan change issue end */